var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38815 4H19.2429C21.0215 4 22.4749 5.35645 22.5731 7.06558L22.5784 7.25V16.75C22.5784 18.483 21.1862 19.8992 19.4322 19.9949L19.2429 20H5.38815C3.60957 20 2.15613 18.6435 2.05801 16.9344L2.05273 16.75V7.25C2.05273 5.51697 3.44483 4.10075 5.19888 4.00514L5.38815 4ZM21.0389 9.373L12.674 13.6637C12.4817 13.7623 12.2572 13.7764 12.0557 13.706L11.9571 13.6637L3.59216 9.374V16.75C3.59216 17.6682 4.31785 18.4212 5.24085 18.4942L5.38815 18.5H19.2429C20.1853 18.5 20.9581 17.7929 21.033 16.8935L21.0389 16.75V9.373ZM19.2429 5.5H5.38815C4.44585 5.5 3.67304 6.20711 3.59811 7.10647L3.59216 7.25V7.679L12.3155 12.1525L21.0389 7.678V7.25C21.0389 6.33183 20.3133 5.57881 19.3902 5.5058L19.2429 5.5Z",
    fill: "#B4B6C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.eecbb809ce7eb87d030bd9fdbf64e1a0.svg";
export { ForwardRef as ReactComponent };